/**
 * Watch for changes in the cell phone and validate it against the library.
 */
App.directive('ngValidateUsername', [function() {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            void 0;
            void 0;
            void 0;

            /**
             * Specifically watch for changes in the input.
             */
            scope.$watch(attrs.ngModel, function() {
                var username = elem.val().trim(),
                    isValid = true,
                    trimmedUsername;

                void 0;
                void 0;

                // disallow special chars at beginning and ending
                trimmedUsername = username.replace(/^[.\-]+|[.\-]+$/g, '');
                void 0;
                if (username != trimmedUsername) {
                    void 0;
                    isValid = false;
                // check for invalid characters
                } else if (!(/^[a-zA-Z0-9.\-]+$/.test(username))) {
                    void 0;
                    isValid = false;
                // don't allow it to start with digits
                } else if  (/^[0-9]+/.test(username)) {
                    void 0;
                    return false;
                // don't allow consecutive special characters
                } else if (/[.\-]{2,}/.test(username)) {
                    void 0;
                    return false;
                }

                ngModel.$setValidity('ngValidateUsername', isValid);
            });

        }
    }
}]);
